import moment from 'moment';
/**
 * Methods for mutating data. 
 * NOTE: This means the data values themselves will be changed.
 */
export default class TabulatorMutators {
    /**
     * Mutates the given cell value based on a provided estimate date Moment object and the presence of
     * a substring in the row's description. Janky as hell, but it's the logic that was using in the original
     * site's codebase.
     * 
     * Also calls timesHundredMutator internally to multiply the value by 100 in specified in the params.
     * 
     * @param value The value to mutate
     * @param data The row data
     * @param type The type of mutation occurring  (data|edit)
     * @param params Mutator params object
     * @param component When the "type" argument is "edit", this contains the cell component for
     *                  the edited cell, otherwise it is the column component for the column
     * @returns 
     */
    static fcpSettlementEstimateMutator = (value, data, type, params: {estimateDate: moment.Moment, multiply: boolean}, component): string => {
        if (params.estimateDate && data.Contract_Description.includes('Total Price') && moment(data.Contract_Date).format('MMM-YYYY') === params.estimateDate.format('MMM-YYYY')){
            return '—';
        }

        return params.multiply 
            ? TabulatorMutators.timesHundredMutator(value, data, type, params, component)
            : value;
    }

    /**
     * Mutates the given value by multiplying by 100 if the value is present and not numeric.
     * Returns a string rounded to 2 decimal places.
     * 
     * @param value The value to mutate
     * @param data The row data
     * @param type The type of mutation occurring  (data|edit)
     * @param params Mutator params object
     * @param component When the "type" argument is "edit", this contains the cell component for
     *                  the edited cell, otherwise it is the column component for the column
     * @returns 
     */
     static timesHundredMutator = (value, data, type, params, component): string => {
        const numberValue = Number(value);
        if (!value || Number.isNaN(numberValue)) {
            return '';
        }

        return (numberValue * 100).toFixed(2);
    }
}